import React from "react";
import "./customRadioButton.scss";

const CustomRadioButton = ({
  label,
  name,
  checked,
  handleOnchange,
  value,
  type = "checkbox",
  disabled,
  border
}) => {
  return (
    <>
      <label
        className={`customCheckbox ${checked ? "customCheckboxActive" : ""}`}
      >
        <input
          type={type}
          name={name}
          checked={checked}
          onChange={(e) => handleOnchange(e)}
          value={value}
          disabled={disabled}
        />
        <span className={border ? "checkMark thinBorder" : "checkMark"}></span>
        {label}
      </label>
    </>
  );
};

export default CustomRadioButton;
